module.exports = __webpack_public_path__ + "static/media/map-overview.8b243675.png";